import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _VideoPlaybackInfoGetter = Getter.of();
export const _VideoPlaybackInfoResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _VideoPlaybackInfoResponse2VideoPlaybackInfo = _Response2ResponseData();
export const _VideoPlaybackInfoResponse2Meta = Fold.compose(_VideoPlaybackInfoResponseGetter, Res._Response(), Lens.prop("meta"));
export const _VideoPlaybackInfo2Data = Fold.compose(_VideoPlaybackInfoGetter, Res._Response());
export const _VideoPlaybackInfo2Attributes = Fold.compose(_VideoPlaybackInfo2Data, Lens.prop("attributes"));
export const _VideoPlaybackInfoAttributes2Streaming = Fold.compose(_VideoPlaybackInfo2Attributes, Lens.prop("streaming"));
export const _VideoPlaybackInfoAttributes2ReportProgressInterval = Fold.compose(_VideoPlaybackInfo2Attributes, Lens.prop("reportProgressInterval"));
export const _VideoPlaybackInfoAttributes2Markers = Fold.compose(_VideoPlaybackInfo2Attributes, Lens.prop("markers"));
export const _VideoPlaybackInfoAttributes2ViewingHistory = Fold.compose(_VideoPlaybackInfo2Attributes, Lens.prop("viewingHistory"));
export const _VideoPlaybackInfoAttributes2UserInfo = Fold.compose(_VideoPlaybackInfo2Attributes, Lens.prop("userInfo"));
export const _VideoPlaybackInfoAttributes2SsaiInfo = Fold.compose(_VideoPlaybackInfo2Attributes, Lens.prop("ssaiInfo"));

